module.exports = __webpack_public_path__ + "img/white-lily.18ce4a7b.webp";